"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var store_1 = require("../store/store");
var satcheljs_1 = require("satcheljs");
exports.default = satcheljs_1.mutatorAction('selectLocaleOption', function selectLocaleOption(locale) {
    var optionState = store_1.default();
    optionState.selectedLocale = locale;
});
//# sourceMappingURL=selectLocaleOption.js.map


//////////////////
// WEBPACK FOOTER
// ./obj/options/config/general/owa-regional-option/lib/data/mutators/selectLocaleOption.js
// module id = 4934
// module chunks = 2